export default Object.freeze({
  ALERT_TYPE_ERROR: 'error',
  ALERT_TYPE_SUCCESS: 'success',
  ALERT_TYPE_INFO: 'info',
  PROCESS_TYPE_CHECK_IN: 'checkin',
  PROCESS_TYPE_CHECK_OUT: 'checkout',
  PROCESS_TYPE_REGISTER: 'register',
  RECORD_TYPE_VISITOR: 'visitor',
  RECORD_TYPE_STAFF: 'staff',
  RECORD_TYPE_CONTRACTOR: 'contractor'
})
